import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';

const OrganisationRoute = ({ ...props }) => (
  <Route
    {...props}
    render={renderProps =>
      props.organisationId ? (
        props.Component ? (
          props.Component
        ) : (
          props.render()
        )
      ) : (
        <Redirect
          to={{ pathname: '/', state: { from: renderProps.location } }}
        />
      )
    }
  />
);

const mapStateToProps = state => {
  const { serviceConfigurationResponse } = state.organisation;

  const organisationId = serviceConfigurationResponse?.organisationId;

  return {
    organisationId
  };
};

const composedOrganisationRoute = compose(connect(mapStateToProps))(
  OrganisationRoute
);

export { composedOrganisationRoute as OrganisationRoute };
